export const CLIENT_STATUS = {
  prospect: { label: "Devis à faire", cls: "bg-slate-100 text-slate-700" },
  devis_envoye: { label: "Devis envoyé", cls: "bg-blue-50 text-blue-700" },
  relance: { label: "Relancé", cls: "bg-amber-50 text-amber-700" },
  valide: { label: "Validé", cls: "bg-teal-50 text-teal-700" },
  effectue: { label: "Effectué", cls: "bg-emerald-50 text-emerald-700" },
};

export const QUOTE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-slate-100 text-slate-700" },
  envoye: { label: "Envoyé", cls: "bg-blue-50 text-blue-700" },
  accepte: { label: "Accepté", cls: "bg-teal-50 text-teal-700" },
  refuse: { label: "Refusé", cls: "bg-red-50 text-red-700" },
};

export const MOVE_STATUS = {
  planifie: { label: "Planifié", cls: "bg-slate-100 text-slate-700", dot: "bg-slate-400" },
  confirme: { label: "Confirmé", cls: "bg-blue-50 text-blue-700", dot: "bg-blue-600" },
  en_cours: { label: "En cours", cls: "bg-amber-50 text-amber-700", dot: "bg-amber-500" },
  termine: { label: "Terminé", cls: "bg-teal-50 text-teal-700", dot: "bg-teal-500" },
};

export const INVOICE_STATUS = {
  en_attente: { label: "En attente", cls: "bg-slate-100 text-slate-700" },
  acompte_recu: { label: "Acompte reçu", cls: "bg-blue-50 text-blue-700" },
  payee: { label: "Payée", cls: "bg-teal-50 text-teal-700" },
  en_retard: { label: "En retard", cls: "bg-red-50 text-red-700" },
};

export const RESOURCE_STATUS = {
  disponible: { label: "Disponible", cls: "bg-teal-50 text-teal-700" },
  en_mission: { label: "En mission", cls: "bg-blue-50 text-blue-700" },
  maintenance: { label: "Maintenance", cls: "bg-amber-50 text-amber-700" },
  conge: { label: "Congé", cls: "bg-slate-100 text-slate-700" },
};

export const STAFF_ROLES = {
  chef_equipe: "Chef d'équipe",
  chauffeur_pl: "Chauffeur PL",
  porteur: "Porteur",
  monteur: "Monteur / emballeur",
};

export const VEHICLE_TYPES = {
  fourgon: "Fourgon",
  camion: "Camion",
  semi: "Semi-remorque",
  monte_meuble: "Monte-meuble",
};

export const ROLES = {
  owner: "Administrateur",
  commercial: "Commercial",
  chef_equipe: "Chef d'équipe",
  equipier: "Équipier terrain",
};

export const ROLE_DESCRIPTIONS = {
  owner: "Accès complet, paramètres et gestion de l'équipe.",
  commercial: "Clients, devis, factures, planning et assistant IA. Flotte en lecture.",
  chef_equipe: "Planning, véhicules, équipes et application Nomade.",
  equipier: "Application Nomade uniquement : planning, photos, signatures, comptes rendus, dépenses.",
};

const ROLE_PERMS = {
  owner: ["*"],
  commercial: ["clients", "quotes", "invoices", "moves", "ai", "dashboard", "fleet:read"],
  chef_equipe: ["moves", "fleet", "dashboard", "field"],
  equipier: ["field"],
};

export const canWrite = (user, perm) => {
  const p = ROLE_PERMS[user?.role] || [];
  return p.includes("*") || p.includes(perm);
};

export const hasFeature = (user, feature) => !feature || (user?.subscription?.features || []).includes(feature);

export const FEATURE_TIER = { field: "Pro", einvoicing: "Pro", accounting: "Pro", ai: "Premium", optimizer: "Premium" };

export const can = (user, perm) => canWrite(user, perm) || (ROLE_PERMS[user?.role] || []).includes(`${perm}:read`);

export const EXPENSE_CATEGORIES = {
  carburant: "Carburant",
  peage: "Péage",
  repas: "Repas",
  parking: "Parking",
  materiel: "Matériel",
  hebergement: "Hébergement",
  autre: "Autre",
};

export const PHOTO_STAGES = { avant: "Avant", pendant: "Pendant", apres: "Après", dommage: "Dommage" };

export const FORMULAS = {
  eco: "Économique",
  standard: "Standard",
  luxe: "Luxe (clé en main)",
};
